// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"359":"lineminiapp","360":"developer","443":"about","721":"kaishuu"}[chunkId] + "." + {"359":"c6691b9b","360":"bd715065","443":"7ee08768","721":"485f2906"}[chunkId] + ".css";
};